<template>
  <div class="card">
    <div class="p-6">
      <div class="text-2xl font-semibold flex items-center gap-2 mb-6">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-primary">
          <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
          <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
          <path d="M10 9H8"></path>
          <path d="M16 13H8"></path>
          <path d="M16 17H8"></path>
        </svg>
        知情同意书
      </div>

      <div class="space-y-6">
        <!-- 评估目的 -->
        <div class="space-y-3">
          <div class="flex items-start gap-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-secondary mt-1 flex-shrink-0">
              <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
            <div>
              <h3 class="font-semibold mb-2">评估目的</h3>
              <p class="text-sm text-gray-600 leading-relaxed">
                本评估旨在帮助{{ subjectPronoun }}了解{{ targetPerson }}在恋爱关系中的占有欲特征，包括控制欲望、嫉妒强度、
                情感依赖和关系不安全感等方面。这是一个基于心理学研究的自我探索工具，
                可以促进{{ subjectPronoun }}对亲密关系动态的认知和理解，帮助建立更健康和谐的恋爱关系。
              </p>
            </div>
          </div>
          <div class="ml-8">
            <label class="flex items-start gap-2 text-sm cursor-pointer">
              <input 
                type="checkbox" 
                v-model="consents.purpose"
                class="mt-1 h-4 w-4 rounded border-gray-300 text-psychology-primary focus:ring-psychology-primary"
              />
              <span>{{ selfPronoun }}理解本评估的目的是帮助{{ selfPronoun }}了解{{ targetPerson }}在恋爱关系中的占有欲特征</span>
            </label>
          </div>
        </div>

        <!-- 隐私保护 -->
        <div class="space-y-3">
          <div class="flex items-start gap-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-secondary mt-1 flex-shrink-0">
              <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
            </svg>
            <div>
              <h3 class="font-semibold mb-2">隐私保护</h3>
              <p class="text-sm text-gray-600 leading-relaxed">
                {{ pronoun }}所有回答将完全匿名化处理，仅保存在{{ pronoun }}设备本地，不会上传到任何服务器。
                我们不收集任何可识别个人身份的信息。{{ subjectPronoun }}可以随时删除本地保存的数据，
                也可以选择导出数据用于个人记录。{{ pronoun }}隐私和数据安全是我们的首要关注。
              </p>
            </div>
          </div>
          <div class="ml-8">
            <label class="flex items-start gap-2 text-sm cursor-pointer">
              <input 
                type="checkbox" 
                v-model="consents.privacy"
                class="mt-1 h-4 w-4 rounded border-gray-300 text-psychology-primary focus:ring-psychology-primary"
              />
              <span>{{ selfPronoun }}理解{{ pronoun }}数据将被匿名化处理并仅保存在本地设备上</span>
            </label>
          </div>
        </div>

        <!-- 自愿参与 -->
        <div class="space-y-3">
          <div class="flex items-start gap-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-secondary mt-1 flex-shrink-0">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
            <div>
              <h3 class="font-semibold mb-2">自愿参与</h3>
              <p class="text-sm text-gray-600 leading-relaxed">
                参与本评估完全基于自愿原则。您可以在任何时候退出评估，无需说明理由。
                对于任何让您感到不适的问题，您都可以选择跳过。评估过程中如果您感到不适，
                请立即停止并寻求专业心理健康服务的帮助。
              </p>
            </div>
          </div>
          <div class="ml-8">
            <label class="flex items-start gap-2 text-sm cursor-pointer">
              <input 
                type="checkbox" 
                v-model="consents.voluntary"
                class="mt-1 h-4 w-4 rounded border-gray-300 text-psychology-primary focus:ring-psychology-primary"
              />
              <span>{{ selfPronoun }}理解参与是自愿的，可以随时退出评估</span>
            </label>
          </div>
        </div>

        <!-- 非诊断性质 -->
        <div class="space-y-3">
          <div class="flex items-start gap-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-warning mt-1 flex-shrink-0">
              <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
              <path d="M12 9v4"></path>
              <path d="M12 17h.01"></path>
            </svg>
            <div>
              <h3 class="font-semibold mb-2">非诊断性质</h3>
              <p class="text-sm text-gray-600 leading-relaxed">
                本评估结果仅供自我了解和关系反思使用，<strong>不能替代专业的心理咨询或情感咨询</strong>。
                如果您在恋爱关系中遇到严重问题（如家庭暴力、严重控制等），建议立即寻求专业帮助。
                评估结果不应被用于指责伴侣或做出重大关系决策。
              </p>
            </div>
          </div>
          <div class="ml-8">
            <label class="flex items-start gap-2 text-sm cursor-pointer">
              <input 
                type="checkbox" 
                v-model="consents.nonDiagnostic"
                class="mt-1 h-4 w-4 rounded border-gray-300 text-psychology-primary focus:ring-psychology-primary"
              />
              <span>我理解这不是诊断工具，如有严重关系问题会寻求专业帮助</span>
            </label>
          </div>
        </div>

        <!-- 重要提醒 -->
        <div class="bg-psychology-warning/5 border border-psychology-warning/20 rounded-lg p-4">
          <div class="flex items-start gap-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-warning mt-0.5 flex-shrink-0">
              <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
              <path d="M12 9v4"></path>
              <path d="M12 17h.01"></path>
            </svg>
            <div class="text-sm">
              <strong>重要提醒：</strong>如果您目前正在经历严重的关系暴力、极端控制、或有自伤/伤人倾向，
              请立即寻求专业帮助（报警或联系家暴热线）。本评估不适合处于危险关系或急性心理危机状态的人群。
            </div>
          </div>
        </div>

        <!-- 按钮 -->
        <div class="flex justify-between pt-4 border-t">
          <div class="flex gap-3 ml-auto">
            <button 
              @click="handleDisagree"
              class="btn-secondary"
            >
              我不同意
            </button>
            <button 
              @click="handleAgree"
              :disabled="!allConsented"
              :class="[
                'btn-primary',
                !allConsented && 'opacity-50 cursor-not-allowed'
              ]"
            >
              我同意并开始评估
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { clearSessionProgress } from '../../utils/sessionStorage.js'

export default {
  name: 'ConsentForm',
  props: {
    assessmentType: {
      type: String,
      default: 'self'
    }
  },
  data() {
    return {
      consents: {
        purpose: false,
        privacy: false,
        voluntary: false,
        nonDiagnostic: false
      }
    }
  },
  computed: {
    pronoun() {
      return this.assessmentType === 'self' ? '您的' : 'Ta的'
    },
    subjectPronoun() {
      return this.assessmentType === 'self' ? '您' : 'Ta'
    },
    selfPronoun() {
      return this.assessmentType === 'self' ? '我' : '我'
    },
    targetPerson() {
      return this.assessmentType === 'self' ? '自己' : '恋人'
    },
    allConsented() {
      return Object.values(this.consents).every(consent => consent === true)
    }
  },
  methods: {
    handleAgree() {
      if (this.allConsented) {
        // 清除之前的评测完成标志和进度，开始新的评测
        localStorage.removeItem('rpi_assessment_completed')
        clearSessionProgress()
        
        // 保存同意状态
        localStorage.setItem('rpi_consent', JSON.stringify({
          agreed: true,
          timestamp: new Date().toISOString()
        }))
        
        // 跳转到基本信息页面，不创建会话
        const assessmentType = this.$route.query.type || 'self'
        this.$router.push({
          path: '/assessment/info',
          query: { 
            type: assessmentType
          }
        })
      }
    },
    handleDisagree() {
      this.$router.push('/')
    }
  }
}
</script>

